import { useState } from 'react';
import { Stack } from '@mui/material';

import { AttributeAppModel } from '@api';

import AppModal from '@common/ui/AppModal';
import { EmptyState, Loader, SearchBar } from '@components';
import { useAppListIdentities } from '@common/services/accountQueries';
import UserBanner from '@Groups/components/UserBanner';

interface IdentitiesByAttributeModalProps {
  attribute: AttributeAppModel;
  onClose: () => void;
}

export default function IdentitiesByAttributeModal({ attribute, onClose }: IdentitiesByAttributeModalProps) {
  const [search, setSearch] = useState('');
  const { identities, isFetched } = useAppListIdentities();

  const filteredIdentities = identities.filter((user) => {
    if (!user.attributes.some((attr) => attr.id === attribute.id)) return false;

    const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
    const email = user.email.toLowerCase();
    const searchValue = search.toLowerCase();
    return fullName.includes(searchValue) || email.includes(searchValue);
  });

  return (
    <AppModal
      open
      onClose={onClose}
      header={`View users by ${attribute.type.display_name} - ${attribute.value}`}
      width={540}
    >
      <Stack spacing={2}>
        <SearchBar value={search} onChange={setSearch} total={filteredIdentities.length} />
        <Stack spacing={1}>
          {!isFetched && <Loader absolute={false} />}
          {isFetched && filteredIdentities.length === 0 && <EmptyState title="No users found" />}
          {filteredIdentities.map((user) => (
            <UserBanner
              key={user.id}
              firstName={user.first_name}
              lastName={user.last_name}
              email={user.email}
              role={user.roles.length > 0 ? user.roles[0] : undefined}
            />
          ))}
        </Stack>
      </Stack>
    </AppModal>
  );
}
